//Core module
import React from 'react';

//External module
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";

//Internal module
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyGoogleAdsLog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {

        const formName = process.env.REACT_APP_GOOGLEADSLOG_FORMNAME;

        return (
            <>
                <div className={`d-flex`}>
                    <div className={'cursor-pointer ml-2 mb-2'} onClick={(e) => {this.props.onBackAction(e)}}>
                        <FontAwesomeIcon className={`phone-icon`} icon={faArrowLeft}/> Go Back
                    </div>
                </div>
                <LegacyFrame withHeader={false} pageTitle={"GoogleAds Logs"} integratedType={this.props.integratedType} webhookid={this.props.webhookid} formname={formName} customClass={"field-customization-container"} />
            </>

        );
    }
}

export default LegacyGoogleAdsLog;
